var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxBrightnessLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.668a.833.833 0 0 0-.833.833v1.667a.833.833 0 1 0 1.666 0V2.5A.833.833 0 0 0 10 1.668zM10 15.001a.833.833 0 0 0-.833.833v1.667a.833.833 0 0 0 1.666 0v-1.667a.833.833 0 0 0-.833-.833zM17.5 9.168a.833.833 0 0 1 0 1.666h-1.667a.833.833 0 0 1 0-1.666H17.5zM5 10.001a.833.833 0 0 0-.833-.833H2.5a.833.833 0 0 0 0 1.666h1.667c.46 0 .833-.373.833-.833zM14.714 4.109a.833.833 0 0 1 1.179 1.178l-1.179 1.179a.833.833 0 1 1-1.178-1.179l1.178-1.178zM6.464 13.537a.833.833 0 0 0-1.178 0l-1.179 1.178a.833.833 0 1 0 1.179 1.179l1.178-1.179a.833.833 0 0 0 0-1.178zM15.893 14.715a.833.833 0 1 1-1.179 1.179l-1.178-1.179a.833.833 0 0 1 1.178-1.178l1.178 1.178zM6.464 6.466a.833.833 0 0 0 0-1.179L5.286 4.109a.833.833 0 0 0-1.179 1.178l1.179 1.179a.833.833 0 0 0 1.178 0z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11.668a1.667 1.667 0 1 0 0-3.334 1.667 1.667 0 0 0 0 3.334zm0 1.666a3.333 3.333 0 1 0 0-6.666 3.333 3.333 0 0 0 0 6.666z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxBrightnessLine);
export default __webpack_public_path__ + "static/media/bx-brightness-line.c133826e46b047093f941c8d9c28e159.svg";
export { ForwardRef as ReactComponent };